import { Host, h } from "@stencil/core";
export class ChSidebarMenuList {
    constructor() {
        this.listType = "list-one";
    }
    el;
    componentWillLoad() {
        /*
        Set the type of list
        list-three : has two parent lists
        list-two : has one parent list
        list-one : has no parent lists. It is the main list (this is the default)
        */
        if (this.el.parentNode.parentElement !== null) {
            if (this.el.parentNode.parentElement.nodeName === "CH-SIDEBAR-MENU-LIST") {
                this.listType = "list-two";
            }
        }
        if (this.el.parentNode.parentElement.parentElement.parentElement !== null) {
            if (this.el.parentNode.parentElement.parentNode.parentElement.nodeName ===
                "CH-SIDEBAR-MENU-LIST") {
                this.listType = "list-three";
            }
        }
    }
    render() {
        return (h(Host, { class: {
                "list-one": this.listType === "list-one",
                "list-two": this.listType === "list-two",
                "list-three": this.listType === "list-three"
            } }, h("slot", null)));
    }
    static get is() { return "ch-sidebar-menu-list"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-sidebar-menu-list.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-sidebar-menu-list.css"]
        };
    }
    static get states() {
        return {
            "listType": {}
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=ch-sidebar-menu-list.js.map
